import { IconProps } from '.';

const MortgageIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      className={customClasses}
      {...rest}
    >
      <g clipPath="url(#clip0_18177_142901)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.416992 2C0.416992 1.30964 0.976636 0.75 1.66699 0.75H28.3337C29.024 0.75 29.5837 1.30964 29.5837 2V32C29.5837 32.6904 29.024 33.25 28.3337 33.25H1.66699C0.976636 33.25 0.416992 32.6904 0.416992 32V2ZM2.91699 3.25V9.908C4.04973 11.2882 6.85944 13.5981 11.1717 14.5199C11.8101 13.0377 13.284 12 15.0003 12C16.7168 12 18.1909 13.038 18.8292 14.5205C23.1392 13.6 25.9487 11.2927 27.0837 9.91176V3.25H2.91699ZM10.9214 17.0215C11.3157 18.9126 12.9921 20.3333 15.0003 20.3333C17.0083 20.3333 18.6845 18.913 19.0791 17.0221C22.5565 16.3303 25.2513 14.8336 27.0837 13.3682V30.75H2.91699V13.3657C4.74884 14.8314 7.44366 16.329 10.9214 17.0215Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
      </g>
      <defs>
        <clipPath id="clip0_18177_142901">
          <rect
            width="40"
            height="40"
            fill={color || 'var(--color-ui-icon-primary)'}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MortgageIcon;
